import { toast } from "react-toastify";
import { getDataSimple, postData } from "../../utils/serverHelper";
import { TIMINGS } from "../../utils/urls";
import { addTimingsFail, addTimingsRequest, addTimingsSuccess, loadingTimingsFail, loadingTimingsRequest, loadingTimingsSuccess } from "./reducer";

export const getStaffTimingsByStaff = async (dispatch,id,business_id,date,) => {
    try {
        console.log('here verify');
        dispatch(loadingTimingsRequest());
        // console.log(dataP);
        const data = await getDataSimple(TIMINGS(business_id,id,date));
        console.log('here here verify', data?.data);
        dispatch(loadingTimingsSuccess(data.data));
        // await getBusinessServices(dispatch,business_id);
    } catch (error) {
        toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
        console.log(error, 'log here verify');
        dispatch(loadingTimingsFail({ message: error.response?.data?.error?.message || error?.message }));
    }
}

export const addStaffTimingsForStaff = async (dispatch,id,business_id,date,dataP,recurring) => {
    try {
        dispatch(addTimingsRequest());
        console.log(dataP);
        await postData(TIMINGS(business_id,id,date),{timings:dataP,recurring});
        dispatch(addTimingsSuccess());
    } catch (error) {
        toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
        console.log(error, 'log here verify');
        dispatch(addTimingsFail({ message: error.response?.data?.error?.message || error?.message }));
    }
}